export default "__VITE_ASSET__8dadb59b__"